<template>
  <!-- 表示領域 -->
  <div class="edit-schedule-wrapper-area">
    <!-- 時間 -->
    <div class="input-form-area">
      <div class="input-form">
        <label class="form-title" for="streaming-start-time">配信開始</label><br />
        <input
          type="time"
          name="streaming-start-time"
          id="streaming-start-time"
          class="input-time"
          :value="streamingStartTime"
          :disabled="isDisabled"
          @change="setStreamingStartTime"
        />
      </div>
      <label class="between-time">〜</label>
      <div class="input-form">
        <label class="form-title" for="streaming-end-time">配信終了</label><br />
        <input
          type="time"
          name="streaming-end-time"
          id="streaming-end-time"
          class="input-time"
          :value="streamingEndTime"
          :disabled="isDisabled"
          @change="setStreamingEndTime"
        />
      </div>
    </div>
    <!-- 曜日 -->
    <div class="input-form select-days-of-week-form">
      <p class="form-title">配信曜日</p>
      <div class="day-of-week-button-area">
        <button
          v-for="(selectableDayOfWeek, index) in SELECTABLE_DAYS_OF_WEEK"
          :key="index"
          :class="[
            'day-of-week-button',
            { 'is-selected': isActiveDayOfWeekButton(selectableDayOfWeek) },
          ]"
          :disabled="isDisabled"
          @click="dayOfWeekButtonClick(selectableDayOfWeek)"
        >
          {{ selectableDayOfWeek }}
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed, toRefs } from 'vue';

// definePropsで親コンポーネントから渡されるprops（プロパティ）を型定義付きで宣言する
const props = defineProps({
  setStreamingStartTime: Function,
  setStreamingEndTime: Function,
  dayOfWeekButtonClick: Function,
  streamingStartTime: String,
  streamingEndTime: String,
  selectedDaysOfWeek: Array,
  isDisabled: Boolean,
});

// propsオブジェクトから各値を分割代入して取り出すことで、以降はprops.<プロパティ名>と書かず、各変数を直接使えるようにする
// toRefsを使用して、リアクティビティを維持する
const {
  setStreamingStartTime,
  setStreamingEndTime,
  dayOfWeekButtonClick,
  streamingStartTime,
  streamingEndTime,
  selectedDaysOfWeek,
  isDisabled,
} = toRefs(props);

// 選択可能曜日リスト
const SELECTABLE_DAYS_OF_WEEK = ['月', '火', '水', '木', '金', '土', '日'];

/**
 * 選択済曜日リストに引数の曜日が入っているか判定
 */
const isActiveDayOfWeekButton = computed(
  () => (dayOfWeekName) => selectedDaysOfWeek.value.includes(dayOfWeekName)
);
</script>

<style scoped>
.edit-schedule-wrapper-area {
  background: rgba(216, 243, 222, 0.5);
  padding: 3rem 2rem 10rem;
}
.form-title {
  color: #21963b;
  font-size: 1.4rem;
  font-weight: 700;
}
.between-time {
  padding: 0 1rem;
  color: #21963b;
  font-size: 1.4rem;
  font-weight: 700;
  line-height: 5rem;
}
.input-form-area {
  display: flex;
  align-items: end;
}
/** 曜日選択エリア */
.day-of-week-button-area {
  display: flex;
  padding-block: 1rem;
  justify-content: space-between;
  max-width: 40rem;
}

.day-of-week-button {
  color: #aaaaaa;
  border: solid 1px #dddddd;
  background-color: #ffffff;
  height: 4rem;
  width: 4rem;
  padding: 0;
  font-size: 1.5rem;
  border-radius: 50%;
  font-weight: 400;
  text-align: center;
  line-height: 1.2rem;
  flex-shrink: 0;
}
.day-of-week-button.is-selected {
  color: #ffffff;
  background-color: #21963b;
  border: solid 1px #21963b;
  font-weight: 700;
}
.input-form {
  width: 30%;
  min-width: 10rem;
}
.select-days-of-week-form {
  width: 100%;
}
.input-time {
  background-color: white;
  color: #21963b;
  font-size: 1.6rem;
  border-radius: 1rem;
  border: solid 1px #d8f3de;
  height: 5rem;
  width: 100%;
  min-width: 10rem;
  position: relative;
  text-align: center;
  margin-top: 1rem;
  appearance: none;
  -webkit-appearance: none;
  box-sizing: border-box;
}

.input-time::-webkit-calendar-picker-indicator {
  position: absolute;
  opacity: 0;
}
</style>
